
import {
  SET_ACTIVE_CRYPTO_IN_VT,
  PLACE_ORDER_IN_VT,
  PLACE_ORDER_IN_VT_ERROR,
  GET_PARTICULAR_PORTFOLIO_IN_VT,
  SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT,
  SET_SELL_TYPE_IN_VT,
  GET_COINS_IN_PARTICULAR_PORTFOLIO_IN_VT,
  FILTER_PORTID_IN_GET_USER_POSITION_IN_VT,
  SET_ACTIVE_PRICE,
  TOGGLE_VTRADING_ALERT_MODAL,
  SET_SELL_PRICE_FOR_STOP_LIMIT,
  PLACE_SELL_ORDER,
  CANCEL_ORDER_IN_VT,
  MODIFY_ORDER_IN_VT,
  SET_TOTAL_INV_AMOUNT,
  SET_TOTAL_CURRENT_AMOUNT,
  SET_NET_PL,
  CLEAR_VTRADING_ERROR,
  CLEAR_VTRADING_MESSAGE,
  SET_ALREADY_INVESTED,
  START_VTRADING_LOADING,
  STOP_VTRADING_LOADING,
  CLEAR_COINS_DATA,
  SET_QUANTITY,
  CHECK_PAID_PORTFOLIO,
  BUY_NEW_PORTFOLIO,
} from "../types";

import { toast } from "react-toastify";
let customId = "Tradathon_Alert";
const VtradingReducer = (state, action) => {
  switch (action.type) {
    case SET_TOTAL_INV_AMOUNT:
      return { ...state, invAmount: action.payload };
    case SET_TOTAL_CURRENT_AMOUNT:
      return { ...state, currentAmount: action.payload };
    case SET_NET_PL:
      return { ...state, netPL: action.payload };
    case CLEAR_VTRADING_MESSAGE:
      return { ...state, vtradingMessage: null };
    case CLEAR_VTRADING_ERROR:
      return { ...state, vtradingError: null };
    case SET_ACTIVE_CRYPTO_IN_VT:
      localStorage.setItem("activeItemForSell", JSON.stringify(action.payload));
      return {
        ...state,
        activeCrypto: action.payload,
      };
    case CLEAR_COINS_DATA:
      return { ...state, coinsData: null };
    case PLACE_ORDER_IN_VT:
      let data = null;
      if (state.alreadyInvested) {
        data =
          state.alreadyInvested[action.portfolio - 1] === true
            ? (state.alreadyInvested[action.portfolio - 1] = false)
            : state.alreadyInvested;
      }

      localStorage.portfolio = JSON.stringify(data);
      toast.success("Order Executed Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: customId,
      });
      return {
        ...state,
        orderDetails: action.payload,
        alreadyInvested: state.alreadyInvested && data,
      };
    case PLACE_SELL_ORDER:
      toast.success("Order Executed Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: customId,
      });
      return {
        ...state,
        orderDetails: action.payload,
        sellPrice: null,
      };
    case PLACE_ORDER_IN_VT_ERROR:
      toast.error(`${action.payload}`, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: customId,
      });
      return { ...state };
    case SET_ALREADY_INVESTED:
      return {
        ...state,
        alreadyInvested: action.payload,
      };
    case GET_PARTICULAR_PORTFOLIO_IN_VT:
      return { ...state, singlePortfolio: action.payload };
    case SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT:
      return { ...state, activePortID: action.payload };
    case SET_SELL_TYPE_IN_VT:
      return { ...state, orderType: action.payload };
    case CHECK_PAID_PORTFOLIO:
      return {
        ...state,
        position: null,
        historyOrders: null,
        openOrders: null,
        singlePortfolio: null,
      };
    case GET_COINS_IN_PARTICULAR_PORTFOLIO_IN_VT:
      let { openOrders, ...y } =
        action.payload.data[action.activePortfolio - 1];

      return {
        ...state,
        PCSTAmount:
          action.vtButton === "position"
            ? y.curramount - y.lockamount
            : state.PCSTAmount,
        portId: y._id,
        position: action.vtButton === "position" && openOrders,
        historyOrders: action.vtButton === "history" && openOrders,
        openOrders: action.vtButton === "openOrder" && openOrders,
        singlePortfolio:
          action.vtButton === "position"
            ? { data: [{ ...y }] }
            : state.singlePortfolio,
      };

    case FILTER_PORTID_IN_GET_USER_POSITION_IN_VT:
      return {
        ...state,
      };
    case SET_ACTIVE_PRICE:
      return { ...state, activePrice: action.payload };
    case TOGGLE_VTRADING_ALERT_MODAL:
      return { ...state, vtradingAlertModal: !state.vtradingAlertModal };
    case SET_SELL_PRICE_FOR_STOP_LIMIT:
      return { ...state, sellPrice: action.payload };
    case CANCEL_ORDER_IN_VT:
      toast.error("Order cancelled Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: customId,
      });
      return {
        ...state,
        openOrders: state.openOrders.filter(
          (c) => c._id !== action.payload.data._id
        ),
        orderDetails: action.payload,
        singlePortfolio: {
          data: [
            {
              ...state.singlePortfolio.data[0],
              lockamount:
                state.singlePortfolio.data[0].lockamount -
                action.payload.data.total,
            },
          ],
        },
      };
    case MODIFY_ORDER_IN_VT:
      toast.success("Modified order Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: customId,
      });
      // let filteredOrder = state.openOrders.filter(
      //   (c) => c._id === action.payload.data._id
      // );
      return {
        ...state,
        // orderDetails: action.payload,
        activePrice: { ...state.activePrice, orderId: null },
        // openOrders: state.openOrders.map((c) =>
        //   c._id === action.payload.data._id
        //     ? {
        //         ...c,
        //         price: action.payload.data.price,
        //         total: action.payload.data.total,
        //         amount: action.payload.data.amount,
        //       }
        //     : c
        // ),

        // singlePortfolio: {
        //   data: [
        //     {
        //       ...state.singlePortfolio.data[0],
        //       lockamount:
        //         state.singlePortfolio.data[0].lockamount -
        //         filteredOrder[0].total +
        //         action.payload.data.total,
        //     },
        //   ],
        // },
      };
    case START_VTRADING_LOADING:
      return {
        ...state,
        vTradingLoading: true,
      };
    case STOP_VTRADING_LOADING:
      return { ...state, vTradingLoading: false };

    case SET_QUANTITY:
      return { ...state, quantity: action.payload };
    case BUY_NEW_PORTFOLIO:
      toast.success("Purchased Portfolio Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: customId,
      });
      return { ...state };
    default:
      return { ...state };
  }
};

export default VtradingReducer;
